import { RecursiveCSS } from "../theme/GlobalTheme";
import { Box } from "../box/Box";
import { useWindowSize } from "../utils/useResize";
import { Section } from "./Section";
import React from "react";

interface IPageProps {
	children?: React.ReactNode;
	rightSection?: React.ReactNode;
	label?: string;
	description?: string;
	icon?: React.ReactNode;
	sectionRightContent?: React.ReactNode;
	onBack?: () => void;
	disableScroll?: boolean;
	separatePanelsScroll?: boolean;
	sx?: RecursiveCSS;
}

export const Page = (props: IPageProps) => {
	const size = useWindowSize();
	const isMobile = size.width <= 768;
	let fullsize = false;
	if (size.width < 1540) fullsize = true;

	const rightPanelNode = props.rightSection && React.isValidElement(props.rightSection) ? props.rightSection : null;
	const rightPanelProps = rightPanelNode ? (rightPanelNode.props as any) : {};

	const showRightSidePanel = !fullsize && !isMobile && props.rightSection;
	let showRightBelow = fullsize && !isMobile && props.rightSection;

	//!TODO: need to show in any case?
	showRightBelow = false;

	return (
		<Box
			sx={{
				display: "grid",
				gridTemplateColumns: showRightSidePanel
					? `minmax(0,73fr) ${rightPanelProps.sx?.maxWidth ? rightPanelProps.sx.maxWidth : "minmax(350px,27fr)"}`
					: "minmax(0, 1fr)",
				gap: "10px",
				minHeight: showRightBelow ? "auto" : "100%",
			}}>
			<Section
				sx={{
					...(props.disableScroll ? { height: "100%" } : {}),
					...(props.separatePanelsScroll ? { overflow: "auto", minHeight: "0px" } : {}),
					boxShadow: "none",
					flex: 1,
					// NOTE: overflowX intentionally NOT set. Any non-visible value on one axis
					// (hidden, clip, auto, scroll) makes the browser implicitly compute the
					// other axis as `auto`, which creates a scroll-container — breaking
					// `position: sticky` for descendants that should anchor to the viewport.
					// If a specific page truly needs to clip horizontal overflow, set BOTH
					// axes to `clip` via props.sx (it then won't create a scroll-container).
					backgroundColor: "transparent",
					padding: "0px",
					borderRadius: "0px",
					...props.sx,
				}}
				label={props.label}
				description={props.description}
				icon={props.icon}
				rightZone={props.sectionRightContent}>
				{props.children}
			</Section>
			{showRightSidePanel && (
				<Box sx={{ height: "100%", minHeight: "0px", ...(props.separatePanelsScroll ? { overflow: "auto" } : {}) }}>{props.rightSection}</Box>
			)}
			{showRightBelow && <Box sx={{ minHeight: "0px" }}>{props.rightSection}</Box>}
		</Box>
	);
};
